import {
  antimicrobienHeaders,
  antioxidantHeaders,
  defaultHeaders,
  emulsifiantsHeaders,
  fatHeaders,
  foamHeaders,
  gellingHeaders,
  sugarHeaders,
} from "./sheetHeaders";

export function getHeaders(technofuctionality) {
  switch (technofuctionality?.toLowerCase()) {
    case "Agent emulsifiant".toLowerCase():
    case "Agent emulsifiant/Stabilisateur d'emulsion".toLowerCase():
    case "Stabilisateur d'emulsion".toLowerCase():
      return emulsifiantsHeaders;
    case "Agent moussant".toLowerCase():
    case "Agent moussant/Stabilisateur de mousse".toLowerCase():
    case "Stabilisateur de mousse".toLowerCase():
      return foamHeaders;
    case "Antimicrobien".toLowerCase():
      return antimicrobienHeaders;
    case "Antioxidant".toLowerCase():
      return antioxidantHeaders;
    case "Substitut de sucre".toLowerCase():
      return sugarHeaders;
    case "Substitut de matiere grasse".toLowerCase():
    case "Substitut de matiere grasse (Gras sature, Trans gras)".toLowerCase():
    case "Substitut de matiere grasse (Reduire le gras)".toLowerCase():
    case "Substitut de matiere grasse (Trans gras)".toLowerCase():
      return fatHeaders;
    case "Agent gelifiant".toLowerCase():
    case "Agent gelifiant/Epaississant".toLowerCase():
    case "Agent epaississant".toLowerCase():
      return gellingHeaders;
    default:
      return defaultHeaders();
  }
}
